import Invoice from "./invoice/invoice";

const OtherInvoice = () => {
  return <Invoice eventType="Other" />;
};

export default OtherInvoice;
